var MATCH = require('./$.wks')('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.fails-is-regexp.js
// module id = 92
// module chunks = 15